import type { SkillGroup } from "../types/skill";

export const skillGroups: SkillGroup[] = [
  {
    title: "core",
    skills: ["React", "TypeScript", "JavaScript", "REST APIs", "Git"],
  },
  {
    title: "comfortable with",
    skills: ["Next.js", "Tailwind CSS", "Node.js / Express", "Figma"],
  },
  {
    title: "exploring",
    skills: ["React Three.js", "3D web development"],
  },
];
